export default __webpack_public_path__ + "static/events-light-8fe7da9dbf1a6fcc5e9da949bb826301.png";